export default __webpack_public_path__ + "static/media/kathy.02c3005e.jpg";